module.exports = __webpack_public_path__ + "img/sticker-nye-scatbook-es.076517d5.svg";